import React from "react";

export const VisalizeBoardIcon = () => {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#paint0_angular_2996_16099_clip_path)" data-figma-skip-parse="true">
        <g transform="matrix(0 0.00892501 -0.008925 0 10.5 12.5)">
          <foreignObject x="-1027.68" y="-1027.68" width="2055.36" height="2055.36">
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,rgba(220, 122, 245, 1) 0deg,rgba(221, 165, 254, 1) 56.3766deg,rgba(246, 220, 255, 1) 149.977deg,rgba(161, 71, 245, 1) 191.377deg,rgba(205, 135, 255, 1) 230.977deg,rgba(242, 223, 255, 1) 308.377deg,rgba(220, 122, 245, 1) 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M9.53087 4.35842C9.68498 3.88735 10.1177 3.57724 10.6125 3.57495C11.1085 3.58643 11.5421 3.90691 11.6872 4.38711L13.1025 9.07366L13.1032 9.07602C13.2312 9.50789 13.5599 9.82488 13.9614 9.96649L18.6347 11.5092C19.1124 11.6761 19.4227 12.1122 19.4249 12.6193C19.4135 13.1143 19.0932 13.5476 18.6121 13.6928L13.9221 15.1071L13.9197 15.1078C13.4879 15.2355 13.1706 15.5639 13.0288 15.9654L11.4835 20.6397L11.4829 20.6415C11.3282 21.1143 10.8921 21.425 10.395 21.425H10.3741C9.87784 21.4137 9.44399 21.0932 9.29885 20.6128L7.88352 15.9262L7.88284 15.9239C7.75488 15.492 7.42613 15.175 7.02459 15.0334L2.3613 13.4894L2.35905 13.4887C1.89481 13.337 1.57722 12.8964 1.57495 12.3806C1.58639 11.8914 1.91524 11.4532 2.38918 11.3067L7.09373 9.89223C7.52568 9.76452 7.84311 9.43612 7.98498 9.03447L9.53029 4.36017L9.53087 4.35842Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.86666667461395264,&#34;g&#34;:0.64705884456634521,&#34;b&#34;:0.99607843160629272,&#34;a&#34;:1.0},&#34;position&#34;:0.15660156309604645},{&#34;color&#34;:{&#34;r&#34;:0.96785920858383179,&#34;g&#34;:0.86607944965362549,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.41660156846046448},{&#34;color&#34;:{&#34;r&#34;:0.63281941413879395,&#34;g&#34;:0.28060704469680786,&#34;b&#34;:0.96230846643447876,&#34;a&#34;:1.0},&#34;position&#34;:0.53160154819488525},{&#34;color&#34;:{&#34;r&#34;:0.80495357513427734,&#34;g&#34;:0.53188854455947876,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.64160156250},{&#34;color&#34;:{&#34;r&#34;:0.95267170667648315,&#34;g&#34;:0.87471830844879150,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.85660153627395630},{&#34;color&#34;:{&#34;r&#34;:0.86274510622024536,&#34;g&#34;:0.47843137383460999,&#34;b&#34;:0.96078431606292725,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.86666667461395264,&#34;g&#34;:0.64705884456634521,&#34;b&#34;:0.99607843160629272,&#34;a&#34;:1.0},&#34;position&#34;:0.15660156309604645},{&#34;color&#34;:{&#34;r&#34;:0.96785920858383179,&#34;g&#34;:0.86607944965362549,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.41660156846046448},{&#34;color&#34;:{&#34;r&#34;:0.63281941413879395,&#34;g&#34;:0.28060704469680786,&#34;b&#34;:0.96230846643447876,&#34;a&#34;:1.0},&#34;position&#34;:0.53160154819488525},{&#34;color&#34;:{&#34;r&#34;:0.80495357513427734,&#34;g&#34;:0.53188854455947876,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.64160156250},{&#34;color&#34;:{&#34;r&#34;:0.95267170667648315,&#34;g&#34;:0.87471830844879150,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.85660153627395630},{&#34;color&#34;:{&#34;r&#34;:0.86274510622024536,&#34;g&#34;:0.47843137383460999,&#34;b&#34;:0.96078431606292725,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:1.0929972332142011e-15,&#34;m01&#34;:-17.849998474121094,&#34;m02&#34;:19.424949645996094,&#34;m10&#34;:17.850011825561523,&#34;m11&#34;:1.0929980802471483e-15,&#34;m12&#34;:3.5749511718750},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        stroke="url(#paint1_linear_2996_16099)"
        strokeWidth="0.247059"
      />
      <g clipPath="url(#paint2_angular_2996_16099_clip_path)" data-figma-skip-parse="true">
        <g transform="matrix(0 0.003825 -0.003825 0 18.4999 4.50005)">
          <foreignObject x="-1027.68" y="-1027.68" width="2055.36" height="2055.36">
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,rgba(220, 122, 245, 1) 0deg,rgba(221, 165, 254, 1) 56.3766deg,rgba(246, 220, 255, 1) 149.977deg,rgba(161, 71, 245, 1) 191.377deg,rgba(205, 135, 255, 1) 230.977deg,rgba(242, 223, 255, 1) 308.377deg,rgba(220, 122, 245, 1) 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M18.0846 1.01082C18.1507 0.808934 18.3361 0.676028 18.5482 0.675049C18.7608 0.679966 18.9466 0.817316 19.0087 1.02312L19.6153 3.03164L19.6156 3.03265C19.6704 3.21774 19.8113 3.35359 19.9834 3.41428L21.9863 4.07545C22.191 4.14697 22.324 4.33389 22.3249 4.5512C22.32 4.76332 22.1827 4.94905 21.9766 5.01125L19.9666 5.61738L19.9655 5.61768C19.7805 5.67244 19.6445 5.81316 19.5837 5.98525L18.9214 7.98852L18.9212 7.98927C18.8549 8.19191 18.668 8.32505 18.4549 8.32505H18.446C18.2333 8.32024 18.0474 8.18285 17.9852 7.97698L17.3786 5.96846L17.3783 5.96747C17.3235 5.78237 17.1826 5.64651 17.0105 5.58582L15.0119 4.92409L15.011 4.92378C14.812 4.85878 14.6759 4.66997 14.6749 4.44891C14.6798 4.23923 14.8208 4.05145 15.0239 3.98867L17.0401 3.38245C17.2252 3.32772 17.3613 3.18698 17.4221 3.01484L18.0844 1.01157L18.0846 1.01082Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.86666667461395264,&#34;g&#34;:0.64705884456634521,&#34;b&#34;:0.99607843160629272,&#34;a&#34;:1.0},&#34;position&#34;:0.15660156309604645},{&#34;color&#34;:{&#34;r&#34;:0.96785920858383179,&#34;g&#34;:0.86607944965362549,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.41660156846046448},{&#34;color&#34;:{&#34;r&#34;:0.63281941413879395,&#34;g&#34;:0.28060704469680786,&#34;b&#34;:0.96230846643447876,&#34;a&#34;:1.0},&#34;position&#34;:0.53160154819488525},{&#34;color&#34;:{&#34;r&#34;:0.80495357513427734,&#34;g&#34;:0.53188854455947876,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.64160156250},{&#34;color&#34;:{&#34;r&#34;:0.95267170667648315,&#34;g&#34;:0.87471830844879150,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.85660153627395630},{&#34;color&#34;:{&#34;r&#34;:0.86274510622024536,&#34;g&#34;:0.47843137383460999,&#34;b&#34;:0.96078431606292725,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.86666667461395264,&#34;g&#34;:0.64705884456634521,&#34;b&#34;:0.99607843160629272,&#34;a&#34;:1.0},&#34;position&#34;:0.15660156309604645},{&#34;color&#34;:{&#34;r&#34;:0.96785920858383179,&#34;g&#34;:0.86607944965362549,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.41660156846046448},{&#34;color&#34;:{&#34;r&#34;:0.63281941413879395,&#34;g&#34;:0.28060704469680786,&#34;b&#34;:0.96230846643447876,&#34;a&#34;:1.0},&#34;position&#34;:0.53160154819488525},{&#34;color&#34;:{&#34;r&#34;:0.80495357513427734,&#34;g&#34;:0.53188854455947876,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.64160156250},{&#34;color&#34;:{&#34;r&#34;:0.95267170667648315,&#34;g&#34;:0.87471830844879150,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.85660153627395630},{&#34;color&#34;:{&#34;r&#34;:0.86274510622024536,&#34;g&#34;:0.47843137383460999,&#34;b&#34;:0.96078431606292725,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:4.6842737810043485e-16,&#34;m01&#34;:-7.6499991416931152,&#34;m02&#34;:22.324926376342773,&#34;m10&#34;:7.6500043869018555,&#34;m11&#34;:4.6842769573779007e-16,&#34;m12&#34;:0.6750488281250},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        stroke="url(#paint3_linear_2996_16099)"
        strokeWidth="0.105882"
      />
      <defs>
        <clipPath id="paint0_angular_2996_16099_clip_path">
          <path
            d="M9.53087 4.35842C9.68498 3.88735 10.1177 3.57724 10.6125 3.57495C11.1085 3.58643 11.5421 3.90691 11.6872 4.38711L13.1025 9.07366L13.1032 9.07602C13.2312 9.50789 13.5599 9.82488 13.9614 9.96649L18.6347 11.5092C19.1124 11.6761 19.4227 12.1122 19.4249 12.6193C19.4135 13.1143 19.0932 13.5476 18.6121 13.6928L13.9221 15.1071L13.9197 15.1078C13.4879 15.2355 13.1706 15.5639 13.0288 15.9654L11.4835 20.6397L11.4829 20.6415C11.3282 21.1143 10.8921 21.425 10.395 21.425H10.3741C9.87784 21.4137 9.44399 21.0932 9.29885 20.6128L7.88352 15.9262L7.88284 15.9239C7.75488 15.492 7.42613 15.175 7.02459 15.0334L2.3613 13.4894L2.35905 13.4887C1.89481 13.337 1.57722 12.8964 1.57495 12.3806C1.58639 11.8914 1.91524 11.4532 2.38918 11.3067L7.09373 9.89223C7.52568 9.76452 7.84311 9.43612 7.98498 9.03447L9.53029 4.36017L9.53087 4.35842Z"
            strokeWidth="0.247059"
          />
        </clipPath>
        <clipPath id="paint2_angular_2996_16099_clip_path">
          <path
            d="M18.0846 1.01082C18.1507 0.808934 18.3361 0.676028 18.5482 0.675049C18.7608 0.679966 18.9466 0.817316 19.0087 1.02312L19.6153 3.03164L19.6156 3.03265C19.6704 3.21774 19.8113 3.35359 19.9834 3.41428L21.9863 4.07545C22.191 4.14697 22.324 4.33389 22.3249 4.5512C22.32 4.76332 22.1827 4.94905 21.9766 5.01125L19.9666 5.61738L19.9655 5.61768C19.7805 5.67244 19.6445 5.81316 19.5837 5.98525L18.9214 7.98852L18.9212 7.98927C18.8549 8.19191 18.668 8.32505 18.4549 8.32505H18.446C18.2333 8.32024 18.0474 8.18285 17.9852 7.97698L17.3786 5.96846L17.3783 5.96747C17.3235 5.78237 17.1826 5.64651 17.0105 5.58582L15.0119 4.92409L15.011 4.92378C14.812 4.85878 14.6759 4.66997 14.6749 4.44891C14.6798 4.23923 14.8208 4.05145 15.0239 3.98867L17.0401 3.38245C17.2252 3.32772 17.3613 3.18698 17.4221 3.01484L18.0844 1.01157L18.0846 1.01082Z"
            strokeWidth="0.105882"
          />
        </clipPath>
        <linearGradient
          id="paint1_linear_2996_16099"
          x1="6.79404"
          y1="4.47066"
          x2="14.2058"
          y2="21.7648"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2996_16099"
          x1="16.9117"
          y1="1.05892"
          x2="20.0881"
          y2="8.47069"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const AIGanttIcon = () => {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.96191 9.12598C9.7554 9.12611 10.3992 9.76902 10.3994 10.5625L10.3916 10.71C10.3178 11.4344 9.70577 11.9999 8.96191 12H2.29492C1.50129 12 0.857554 11.3561 0.857422 10.5625L0.865234 10.416C0.938799 9.69129 1.55079 9.12598 2.29492 9.12598H8.96191ZM2.29492 9.92578C1.94315 9.92578 1.65741 10.2108 1.65723 10.5625C1.65736 10.9143 1.94311 11.2002 2.29492 11.2002H8.96191C9.31361 11.2001 9.59948 10.9142 9.59961 10.5625C9.59942 10.2109 9.31358 9.92591 8.96191 9.92578H2.29492ZM12.4082 4.9248C13.1327 4.99834 13.6979 5.61062 13.6982 6.35449L13.6914 6.50195C13.6226 7.17825 13.0845 7.71548 12.4082 7.78418L12.2617 7.79199H4.86035C4.06663 7.79199 3.42285 7.14821 3.42285 6.35449L3.43066 6.20801C3.50435 5.48341 4.11631 4.91797 4.86035 4.91797H12.2617L12.4082 4.9248ZM4.86035 5.71777C4.50866 5.71777 4.22298 6.00287 4.22266 6.35449C4.22266 6.70638 4.50846 6.99219 4.86035 6.99219H12.2617C12.6134 6.99196 12.8984 6.70624 12.8984 6.35449C12.8981 6.00301 12.6132 5.718 12.2617 5.71777H4.86035ZM10.9434 1.98047C10.9432 1.62874 10.6584 1.34375 10.3066 1.34375H1.4375C1.08584 1.34388 0.799991 1.62882 0.799805 1.98047C0.799937 2.33217 1.0858 2.61803 1.4375 2.61816H10.3066C10.6584 2.61816 10.9432 2.33225 10.9434 1.98047ZM11.7363 2.12793C11.6625 2.85241 11.0506 3.41797 10.3066 3.41797H1.4375C0.643975 3.41784 0.000131953 2.77399 0 1.98047L0.0078125 1.83398C0.0813686 1.10934 0.693475 0.544069 1.4375 0.543945H10.3066C11.1002 0.543945 11.744 1.18691 11.7441 1.98047L11.7363 2.12793Z"
        fill="#7F869B"
      />
    </svg>
  );
};

export const AIBrainstormIcon = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.45312 0.599609C8.25798 0.599698 8.91016 1.25274 8.91016 2.05762C8.91008 2.72317 8.46399 3.28272 7.85449 3.45703V5.5752C8.09679 5.62495 8.32208 5.72035 8.52344 5.84961L10.0508 4.32227C9.93416 4.11283 9.86819 3.87097 9.86816 3.61426C9.86839 2.80952 10.5214 2.15625 11.3262 2.15625C12.1309 2.15634 12.783 2.80957 12.7832 3.61426C12.7831 4.41906 12.131 5.0712 11.3262 5.07129C11.0689 5.07129 10.828 5.00364 10.6182 4.88672L9.09766 6.40723C9.25932 6.64547 9.3685 6.92095 9.41406 7.21777H11.541C11.7151 6.60754 12.2765 6.16026 12.9424 6.16016C13.7472 6.16024 14.3994 6.81329 14.3994 7.61816C14.3993 8.42296 13.7472 9.07511 12.9424 9.0752C12.2765 9.07509 11.7152 8.62849 11.541 8.01855H9.37402C9.3135 8.25287 9.2117 8.4697 9.07617 8.66211L10.5723 10.1543C10.7821 10.0373 11.024 9.96973 11.2812 9.96973C12.0858 9.97004 12.7381 10.6231 12.7383 11.4277C12.7382 12.2324 12.0859 12.8844 11.2812 12.8848C10.4764 12.8848 9.82333 12.2326 9.82324 11.4277C9.8233 11.1707 9.88994 10.9294 10.0068 10.7197L8.49316 9.20996C8.29939 9.32956 8.08491 9.41849 7.85449 9.46582V11.542C8.46404 11.7164 8.91001 12.2768 8.91016 12.9424C8.91007 13.7472 8.25792 14.3993 7.45312 14.3994C6.64847 14.3992 5.99521 13.7471 5.99512 12.9424C5.99526 12.2763 6.44325 11.715 7.05371 11.541V9.4668C6.79366 9.41368 6.5521 9.30994 6.33984 9.16602L4.90332 10.6055C5.02045 10.8154 5.08781 11.0571 5.08789 11.3145C5.0878 12.1192 4.43552 12.7712 3.63086 12.7715C2.82598 12.7715 2.17294 12.1193 2.17285 11.3145C2.17311 10.5097 2.82609 9.85645 3.63086 9.85645C3.88716 9.85653 4.12773 9.92372 4.33691 10.04L5.78125 8.59277C5.66911 8.41825 5.58551 8.22474 5.53223 8.01855H3.45703C3.28292 8.62814 2.72312 9.0749 2.05762 9.0752C1.25282 9.0752 0.598853 8.42291 0.598633 7.61816C0.598633 6.81323 1.25269 6.16016 2.05762 6.16016C2.72336 6.16045 3.28313 6.60765 3.45703 7.21777H5.49219C5.5334 6.94941 5.62732 6.69922 5.76465 6.47754L4.28711 5.00098C4.07761 5.11758 3.8369 5.18552 3.58008 5.18555C2.77537 5.18555 2.12242 4.53315 2.12207 3.72852C2.12207 2.92359 2.77515 2.27051 3.58008 2.27051C4.38493 2.2706 5.03711 2.92364 5.03711 3.72852C5.037 3.98492 4.96984 4.22534 4.85352 4.43457L6.31348 5.89551C6.53221 5.74186 6.78251 5.6296 7.05371 5.57422V3.45703C6.44334 3.28316 5.99519 2.72365 5.99512 2.05762C5.99512 1.25281 6.64836 0.599807 7.45312 0.599609ZM7.45312 12.2852C7.09035 12.2854 6.79607 12.5796 6.7959 12.9424C6.79599 13.3053 7.0903 13.5994 7.45312 13.5996C7.8161 13.5995 8.11026 13.3054 8.11035 12.9424C8.11017 12.5795 7.81604 12.2852 7.45312 12.2852ZM11.2812 10.7705C10.9183 10.7705 10.6242 11.0648 10.624 11.4277C10.6241 11.7908 10.9182 12.085 11.2812 12.085C11.644 12.0846 11.9384 11.7906 11.9385 11.4277C11.9383 11.065 11.644 10.7708 11.2812 10.7705ZM3.63086 10.6572C3.26791 10.6572 2.97389 10.9516 2.97363 11.3145C2.97372 11.6775 3.26781 11.9717 3.63086 11.9717C3.99369 11.9714 4.288 11.6773 4.28809 11.3145C4.28783 10.9517 3.99359 10.6575 3.63086 10.6572ZM7.45312 6.33594C6.79821 6.33607 6.26771 6.86657 6.26758 7.52148C6.26784 8.17629 6.79829 8.70788 7.45312 8.70801C8.10802 8.70794 8.63938 8.17633 8.63965 7.52148C8.63952 6.86653 8.1081 6.336 7.45312 6.33594ZM2.05762 6.96094C1.69452 6.96094 1.40039 7.25506 1.40039 7.61816C1.40061 7.98108 1.69465 8.27539 2.05762 8.27539C2.42028 8.27504 2.71462 7.98086 2.71484 7.61816C2.71484 7.25528 2.42042 6.96129 2.05762 6.96094ZM12.9424 6.96094C12.5794 6.96107 12.2852 7.25514 12.2852 7.61816C12.2852 7.98111 12.5794 8.27526 12.9424 8.27539C13.3054 8.2753 13.5995 7.98114 13.5996 7.61816C13.5996 7.25512 13.3054 6.96103 12.9424 6.96094ZM3.58008 3.07129C3.21698 3.07129 2.92285 3.36541 2.92285 3.72852C2.9232 4.09132 3.21719 4.38574 3.58008 4.38574C3.94289 4.38565 4.23695 4.09126 4.2373 3.72852C4.2373 3.36547 3.9431 3.07138 3.58008 3.07129ZM11.3262 2.95703C10.9632 2.95703 10.6692 3.25135 10.6689 3.61426C10.669 3.97728 10.9631 4.27148 11.3262 4.27148C11.6891 4.2714 11.9833 3.97723 11.9834 3.61426C11.9832 3.2514 11.6891 2.95712 11.3262 2.95703ZM7.45312 1.40039C7.09019 1.40059 6.7959 1.69464 6.7959 2.05762C6.79599 2.42052 7.09025 2.71465 7.45312 2.71484C7.8161 2.71476 8.11026 2.42059 8.11035 2.05762C8.11035 1.69457 7.81615 1.40048 7.45312 1.40039Z"
        fill="#7F869B"
      />
    </svg>
  );
};

export const AIFlowchartIcon = () => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66667 1H2.22222C1.54721 1 1 1.54721 1 2.22222V4.66667C1 5.34168 1.54721 5.88889 2.22222 5.88889H4.66667C5.34168 5.88889 5.88889 5.34168 5.88889 4.66667V2.22222C5.88889 1.54721 5.34168 1 4.66667 1Z"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.44446 5.88892V8.33336C3.44446 8.65751 3.57323 8.96839 3.80244 9.1976C4.03165 9.42681 4.34253 9.55558 4.66668 9.55558H7.11112"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7778 7.11108H8.33331C7.65829 7.11108 7.11108 7.65829 7.11108 8.33331V10.7778C7.11108 11.4528 7.65829 12 8.33331 12H10.7778C11.4528 12 12 11.4528 12 10.7778V8.33331C12 7.65829 11.4528 7.11108 10.7778 7.11108Z"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AIMindmapIcon = () => {
  return (
    <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1426 0.608398C14.3245 0.645982 14.4619 0.806962 14.4619 1C14.4619 1.19304 14.3245 1.35402 14.1426 1.3916L14.0615 1.40039H12.459C12.142 1.40042 11.8298 1.4739 11.5498 1.61523C11.2698 1.75659 11.031 1.9615 10.8516 2.20996L8.95801 4.83203C8.83458 5.00299 8.69132 5.15844 8.53223 5.2959H14.123L14.2031 5.30371C14.3853 5.34085 14.5221 5.50221 14.5225 5.69531C14.5225 5.88869 14.3855 6.05068 14.2031 6.08789L14.123 6.0957H8.78125C8.84352 6.16535 8.90315 6.2375 8.95801 6.31348L10.8516 8.93555C11.031 9.18405 11.2698 9.3889 11.5498 9.53027C11.8299 9.67165 12.142 9.74508 12.459 9.74512H14.0615L14.1426 9.75391C14.3244 9.79145 14.4618 9.95259 14.4619 10.1455C14.4619 10.3385 14.3245 10.4995 14.1426 10.5371L14.0615 10.5459H12.459C12.0176 10.5459 11.5821 10.4423 11.1895 10.2441C10.7968 10.0459 10.4576 9.75818 10.2021 9.4043L8.30859 6.78223C8.12922 6.53379 7.89029 6.32886 7.61035 6.1875C7.33037 6.04615 7.01809 5.97372 6.70117 5.97363H5.97266V6.25977C5.97258 7.18372 5.2228 7.93359 4.29883 7.93359H2.27344C1.34946 7.93359 0.599685 7.18372 0.599609 6.25977V4.88672C0.599609 3.9627 1.34942 3.21289 2.27344 3.21289H4.29883C5.22285 3.21289 5.97266 3.9627 5.97266 4.88672V5.17188H6.71191C7.02513 5.17015 7.33354 5.09775 7.61035 4.95801C7.89027 4.81664 8.12924 4.61172 8.30859 4.36328L10.2021 1.74121C10.4576 1.38738 10.7968 1.09959 11.1895 0.901367C11.582 0.703215 12.0176 0.599642 12.459 0.599609H14.0615L14.1426 0.608398ZM2.27344 4.01367C1.79125 4.01367 1.40039 4.40453 1.40039 4.88672V6.25977C1.40047 6.74189 1.79129 7.13281 2.27344 7.13281H4.29883C4.78097 7.13281 5.1718 6.74189 5.17188 6.25977V5.5918C5.17157 5.5854 5.16992 5.57874 5.16992 5.57227C5.16993 5.56536 5.17152 5.55858 5.17188 5.55176V4.88672C5.17188 4.40453 4.78102 4.01367 4.29883 4.01367H2.27344Z"
        fill="#7F869B"
      />
    </svg>
  );
};

export const AIOneOnOneIcon = () => {
  return (
    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9199 7.19592L7.50601 12.5578L2.09215 7.19592C1.73506 6.84843 1.45378 6.43077 1.26603 5.96923C1.07828 5.5077 0.988131 5.01229 1.00125 4.5142C1.01437 4.01612 1.13048 3.52614 1.34227 3.07513C1.55405 2.62412 1.85693 2.22184 2.23182 1.89364C2.60671 1.56543 3.0455 1.3184 3.52056 1.16811C3.99561 1.01782 4.49663 0.96751 4.99208 1.02036C5.48753 1.07321 5.96667 1.22808 6.39933 1.4752C6.83199 1.72233 7.20879 2.05636 7.50601 2.45626C7.80452 2.05926 8.18176 1.72815 8.61412 1.48365C9.04649 1.23915 9.52466 1.08652 10.0187 1.03532C10.5128 0.984118 11.0121 1.03545 11.4854 1.18609C11.9587 1.33674 12.3958 1.58346 12.7694 1.91081C13.143 2.23816 13.445 2.63909 13.6565 3.08852C13.868 3.53795 13.9844 4.0262 13.9985 4.5227C14.0127 5.01921 13.9242 5.51328 13.7385 5.97401C13.5529 6.43473 13.2742 6.85219 12.9199 7.20025"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.506 2.4519L5.12895 4.82895C4.99362 4.96432 4.9176 5.14789 4.9176 5.3393C4.9176 5.53071 4.99362 5.71428 5.12895 5.84964L5.52091 6.24161C6.01899 6.73968 6.82746 6.73968 7.32553 6.24161L8.04738 5.51976C8.47814 5.08901 9.06236 4.84702 9.67154 4.84702C10.2807 4.84702 10.8649 5.08901 11.2957 5.51976L12.9199 7.14392"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.86694 9.30933L9.31064 10.753"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.67151 7.50488L11.1152 8.94858"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AIOrgchartIcon = () => {
  return (
    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.44922 0.599609C10.1284 0.599869 10.6787 1.15088 10.6787 1.83008V3.54395C10.6786 4.22307 10.1283 4.77318 9.44922 4.77344H8.11914C8.13661 4.81844 8.14746 4.86681 8.14746 4.91797V5.20312C8.15927 5.21359 8.17703 5.22671 8.20117 5.24219C8.30465 5.30842 8.48305 5.38204 8.7373 5.44141L11.1562 6.00586C11.457 6.07605 11.7328 6.17549 11.9424 6.30957C12.1378 6.4347 12.3651 6.65098 12.3652 6.9707V7.34766H13.666C14.3452 7.34792 14.8955 7.89893 14.8955 8.57812V10.292C14.8954 10.9711 14.3451 11.5212 13.666 11.5215H10.2646C9.58549 11.5213 9.0343 10.9712 9.03418 10.292V8.57812C9.03422 7.89888 9.58544 7.34785 10.2646 7.34766H11.5645V7.02246L11.5107 6.9834C11.4072 6.91717 11.2289 6.84352 10.9746 6.78418L8.55566 6.2207C8.25493 6.15051 7.98003 6.05009 7.77051 5.91602C7.7624 5.91082 7.75527 5.90394 7.74707 5.89844C7.73915 5.90375 7.73245 5.911 7.72461 5.91602C7.51505 6.05007 7.24022 6.15052 6.93945 6.2207L4.52051 6.78418C4.26612 6.84355 4.08789 6.91714 3.98438 6.9834L3.93066 7.02246V7.34766H5.23145C5.9106 7.34792 6.46089 7.89893 6.46094 8.57812V10.292C6.46081 10.9711 5.91054 11.5212 5.23145 11.5215H1.83008C1.15082 11.5214 0.599735 10.9712 0.599609 10.292V8.57812C0.599653 7.89881 1.15077 7.34773 1.83008 7.34766H3.12988V6.9707C3.12998 6.65097 3.35736 6.43474 3.55273 6.30957C3.76229 6.17545 4.03804 6.07607 4.33887 6.00586L6.75781 5.44141C7.01208 5.38206 7.19041 5.30842 7.29395 5.24219C7.31813 5.22669 7.33581 5.2136 7.34766 5.20312V4.91797C7.34766 4.86687 7.35848 4.81839 7.37598 4.77344H6.04785C5.36879 4.77313 4.81752 4.22304 4.81738 3.54395V1.83008C4.81743 1.15091 5.36874 0.599914 6.04785 0.599609H9.44922ZM1.83008 8.14844C1.5926 8.14851 1.40043 8.34063 1.40039 8.57812V10.292C1.40052 10.5294 1.59265 10.7216 1.83008 10.7217H5.23145C5.46872 10.7214 5.66101 10.5293 5.66113 10.292V8.57812C5.66109 8.34075 5.46877 8.1487 5.23145 8.14844H1.83008ZM10.2646 8.14844C10.0273 8.14863 9.835 8.34071 9.83496 8.57812V10.292C9.83509 10.5293 10.0273 10.7215 10.2646 10.7217H13.666C13.9033 10.7214 14.0956 10.5293 14.0957 10.292V8.57812C14.0957 8.34075 13.9033 8.1487 13.666 8.14844H10.2646ZM6.04785 1.40039C5.81057 1.40069 5.61821 1.59273 5.61816 1.83008V3.54395C5.6183 3.78121 5.81062 3.97333 6.04785 3.97363H9.44922C9.68648 3.97337 9.87877 3.78124 9.87891 3.54395V1.83008C9.87886 1.59271 9.68654 1.40065 9.44922 1.40039H6.04785Z"
        fill="#7F869B"
      />
    </svg>
  );
};

export const AIPIPlanningIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 2.11111C1 1.81643 1.11706 1.53381 1.32544 1.32544C1.53381 1.11706 1.81643 1 2.11111 1H9.88889C10.1836 1 10.4662 1.11706 10.6746 1.32544C10.8829 1.53381 11 1.81643 11 2.11111V9.88889C11 10.1836 10.8829 10.4662 10.6746 10.6746C10.4662 10.8829 10.1836 11 9.88889 11H2.11111C1.81643 11 1.53381 10.8829 1.32544 10.6746C1.11706 10.4662 1 10.1836 1 9.88889V2.11111Z"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33325 6.00003L5.44436 7.11114L7.66659 4.88892"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AITeamRetroIcon = () => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 6.5C1 7.5878 1.32257 8.65117 1.92692 9.55564C2.53127 10.4601 3.39025 11.1651 4.39524 11.5813C5.40024 11.9976 6.5061 12.1065 7.573 11.8943C8.63989 11.6821 9.6199 11.1583 10.3891 10.3891C11.1583 9.6199 11.6821 8.63989 11.8943 7.573C12.1065 6.5061 11.9976 5.40024 11.5813 4.39524C11.1651 3.39025 10.4601 2.53127 9.55564 1.92692C8.65117 1.32257 7.5878 1 6.5 1C4.96242 1.00578 3.48659 1.60575 2.38111 2.67444L1 4.05556"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1 1V4.05556H4.05556" stroke="#7F869B" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const AITimelineIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.25 13.25C6.25 13.7141 6.43437 14.1592 6.76256 14.4874C7.09075 14.8156 7.53587 15 8 15C8.46413 15 8.90925 14.8156 9.23744 14.4874C9.56563 14.1592 9.75 13.7141 9.75 13.25C9.75 12.7859 9.56563 12.3408 9.23744 12.0126C8.90925 11.6844 8.46413 11.5 8 11.5C7.53587 11.5 7.09075 11.6844 6.76256 12.0126C6.43437 12.3408 6.25 12.7859 6.25 13.25Z"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.25 13.25H1" stroke="#7F869B" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.75 13.25H15" stroke="#7F869B" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8 9.875L6.25 8.125H3.625C3.39294 8.125 3.17038 8.03281 3.00628 7.86872C2.84219 7.70462 2.75 7.48206 2.75 7.25V1.875C2.75 1.64294 2.84219 1.42038 3.00628 1.25628C3.17038 1.09219 3.39294 1 3.625 1H12.375C12.6071 1 12.8296 1.09219 12.9937 1.25628C13.1578 1.42038 13.25 1.64294 13.25 1.875V7.25C13.25 7.48206 13.1578 7.70462 12.9937 7.86872C12.8296 8.03281 12.6071 8.125 12.375 8.125H9.75L8 9.875Z"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AIWeeklySyncIcon = () => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 5.80223C11.8319 4.59238 11.2706 3.47137 10.4027 2.61188C9.53477 1.75239 8.40833 1.20211 7.1969 1.04579C5.98547 0.889481 4.75624 1.13581 3.69858 1.74683C2.64091 2.35786 1.81348 3.29968 1.34375 4.42723M1 1.67723V4.42723H3.75"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 7.17725C1.16813 8.3871 1.72939 9.50811 2.59731 10.3676C3.46523 11.2271 4.59167 11.7774 5.8031 11.9337C7.01453 12.09 8.24376 11.8437 9.30142 11.2326C10.3591 10.6216 11.1865 9.67979 11.6562 8.55225M12 11.3022V8.55225H9.25"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AIFeaturePlanIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.17383 2.11111C1.17383 1.81643 1.29089 1.53381 1.49926 1.32544C1.70764 1.11706 1.99025 1 2.28494 1H10.0627C10.3574 1 10.64 1.11706 10.8484 1.32544C11.0568 1.53381 11.1738 1.81643 11.1738 2.11111V9.88889C11.1738 10.1836 11.0568 10.4662 10.8484 10.6746C10.64 10.8829 10.3574 11 10.0627 11H2.28494C1.99025 11 1.70764 10.8829 1.49926 10.6746C1.29089 10.4662 1.17383 10.1836 1.17383 9.88889V2.11111Z"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.50708 5.99978L5.61819 7.11089L7.84041 4.88867"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AIGolatSetIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1778_26097)">
        <path
          d="M6.41675 6.99984C6.41675 7.15455 6.47821 7.30292 6.5876 7.41232C6.697 7.52171 6.84537 7.58317 7.00008 7.58317C7.15479 7.58317 7.30316 7.52171 7.41256 7.41232C7.52196 7.30292 7.58341 7.15455 7.58341 6.99984C7.58341 6.84513 7.52196 6.69675 7.41256 6.58736C7.30316 6.47796 7.15479 6.4165 7.00008 6.4165C6.84537 6.4165 6.697 6.47796 6.5876 6.58736C6.47821 6.69675 6.41675 6.84513 6.41675 6.99984Z"
          stroke="#7F869B"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.99992 4.0835C6.42306 4.0835 5.85915 4.25456 5.37951 4.57504C4.89986 4.89553 4.52603 5.35105 4.30527 5.884C4.08452 6.41695 4.02676 7.0034 4.1393 7.56918C4.25184 8.13495 4.52962 8.65465 4.93753 9.06256C5.34543 9.47046 5.86513 9.74825 6.43091 9.86079C6.99668 9.97333 7.58313 9.91557 8.11608 9.69481C8.64903 9.47406 9.10455 9.10022 9.42504 8.62058C9.74553 8.14093 9.91659 7.57702 9.91659 7.00016"
          stroke="#7F869B"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58337 1.78225C6.5019 1.66092 5.40947 1.87866 4.45717 2.40535C3.50486 2.93203 2.73977 3.74164 2.26771 4.72216C1.79565 5.70269 1.63995 6.80568 1.82217 7.87857C2.00438 8.95145 2.51549 9.94119 3.28481 10.7109C4.05412 11.4806 5.04361 11.9922 6.11639 12.175C7.18918 12.3577 8.29225 12.2026 9.27302 11.731C10.2538 11.2594 11.0638 10.4948 11.5909 9.54272C12.1181 8.59068 12.3364 7.49835 12.2156 6.41683"
          stroke="#7F869B"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.75 3.5V5.25H10.5L12.25 3.5H10.5V1.75L8.75 3.5Z"
          stroke="#7F869B"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8.75 5.25L7 7" stroke="#7F869B" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1778_26097">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AICampaignBriefIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1778_26092)">
        <path
          d="M9 12V3L14 5.4L9 7.8"
          stroke="#7F869B"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 10.5C4.5 11 4 11.7387 4 12.1982C4 13.1892 6.25 14 9 14C11.75 14 14 13.1892 14 12.1982C14 11.7477 13.5 11 12 10.5"
          stroke="#7F869B"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1778_26092">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AIProcessMapIcon = () => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.06665 2.39974C9.06665 2.75336 9.20713 3.0925 9.45718 3.34255C9.70722 3.5926 10.0464 3.73308 10.4 3.73308C10.7536 3.73308 11.0927 3.5926 11.3428 3.34255C11.5928 3.0925 11.7333 2.75336 11.7333 2.39974C11.7333 2.04612 11.5928 1.70698 11.3428 1.45693C11.0927 1.20688 10.7536 1.06641 10.4 1.06641C10.0464 1.06641 9.70722 1.20688 9.45718 1.45693C9.20713 1.70698 9.06665 2.04612 9.06665 2.39974Z"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.06665 6.39974C1.06665 6.75336 1.20713 7.0925 1.45718 7.34255C1.70722 7.5926 2.04636 7.73308 2.39999 7.73308C2.75361 7.73308 3.09275 7.5926 3.3428 7.34255C3.59285 7.0925 3.73332 6.75336 3.73332 6.39974C3.73332 6.04612 3.59285 5.70698 3.3428 5.45693C3.09275 5.20688 2.75361 5.06641 2.39999 5.06641C2.04636 5.06641 1.70722 5.20688 1.45718 5.45693C1.20713 5.70698 1.06665 6.04612 1.06665 6.39974Z"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.06665 10.3997C1.06665 10.7534 1.20713 11.0925 1.45718 11.3426C1.70722 11.5926 2.04636 11.7331 2.39999 11.7331C2.75361 11.7331 3.09275 11.5926 3.3428 11.3426C3.59285 11.0925 3.73332 10.7534 3.73332 10.3997C3.73332 10.0461 3.59285 9.70698 3.3428 9.45693C3.09275 9.20688 2.75361 9.06641 2.39999 9.06641C2.04636 9.06641 1.70722 9.20688 1.45718 9.45693C1.20713 9.70698 1.06665 10.0461 1.06665 10.3997Z"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.06665 10.3997C9.06665 10.7534 9.20713 11.0925 9.45718 11.3426C9.70722 11.5926 10.0464 11.7331 10.4 11.7331C10.7536 11.7331 11.0927 11.5926 11.3428 11.3426C11.5928 11.0925 11.7333 10.7534 11.7333 10.3997C11.7333 10.0461 11.5928 9.70698 11.3428 9.45693C11.0927 9.20688 10.7536 9.06641 10.4 9.06641C10.0464 9.06641 9.70722 9.20688 9.45718 9.45693C9.20713 9.70698 9.06665 10.0461 9.06665 10.3997Z"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.7334 10.3999H9.06674"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.4 11.7334V12.4001" stroke="#7F869B" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10.4 0.399902V1.06657"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.40002 11.7334V12.4001"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.40002 5.06658V0.399902"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.40002 0.399902V12.3999"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.4 3.7334V9.06674" stroke="#7F869B" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M3.7334 6.3999H12.4001"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4001 2.3999H11.7334"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.06671 2.3999H0.400024"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.400024 6.3999H1.06669"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7334 10.3999H12.4001"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.400024 10.3999H1.06669"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.40002 7.7334V9.06673"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AITeamSyncIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.400024 5.8999C0.400024 6.9877 0.722594 8.05107 1.32694 8.95554C1.93129 9.86001 2.79027 10.565 3.79527 10.9812C4.80026 11.3975 5.90613 11.5064 6.97302 11.2942C8.03992 11.082 9.01992 10.5582 9.78911 9.78899C10.5583 9.0198 11.0821 8.0398 11.2943 6.9729C11.5066 5.906 11.3976 4.80014 10.9814 3.79514C10.5651 2.79015 9.86013 1.93117 8.95566 1.32682C8.05119 0.722472 6.98782 0.399902 5.90003 0.399902C4.36244 0.405687 2.88662 1.00565 1.78114 2.07435L0.400024 3.45546"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.400024 0.399902V3.45546H3.45558"
        stroke="#7F869B"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
